import { AccountingFirmRegion, AccountingFirmType } from '../../../models/box-format.model';

export const TypeList: { [key: string]: { [key in AccountingFirmType]: string } } = {
  th: {
    [AccountingFirmType.All]: 'ทุกประเภท',
    [AccountingFirmType.AccountingFirm]: 'สำนักงานบัญชี',
    [AccountingFirmType.Freelance]: 'นักบัญชีอิสระ',
  },
  en: {
    [AccountingFirmType.All]: 'All Types',
    [AccountingFirmType.AccountingFirm]: 'Accounting Firm',
    [AccountingFirmType.Freelance]: 'Freelance',
  },
}

export const RegionList: { [key: string]: { [key in AccountingFirmRegion]: string } } = {
  th: {
    [AccountingFirmRegion.All]: 'ทุกภูมิภาค',
    [AccountingFirmRegion.BangkokAndSurroundingAreas]: 'กรุงเทพและปริมณฑล',
    [AccountingFirmRegion.NorthEast]: 'ภาคตะวันออกเฉียงเหนือ',
    [AccountingFirmRegion.North]: 'ภาคเหนือ',
    [AccountingFirmRegion.South]: 'ภาคใต้',
    [AccountingFirmRegion.Central]: 'ภาคกลาง',
    [AccountingFirmRegion.East]: 'ภาคตะวันออก',
    [AccountingFirmRegion.West]: 'ภาคตะวันตก',
  },
  en: {
    [AccountingFirmRegion.All]: 'All Regions',
    [AccountingFirmRegion.BangkokAndSurroundingAreas]: 'Bangkok Metropolitan Areas',
    [AccountingFirmRegion.NorthEast]: 'Northeastern',
    [AccountingFirmRegion.North]: 'Northern',
    [AccountingFirmRegion.South]: 'Southern',
    [AccountingFirmRegion.Central]: 'Central',
    [AccountingFirmRegion.East]: 'Eastern',
    [AccountingFirmRegion.West]: 'Western',
  },
}
